import { connect } from 'react-redux';

import { openMessageModal } from 'actions/modal';
import { logout } from 'actions/auth';

import { languageMapRoute } from 'util/i18n';
import { contain } from 'util/container';
import AllCountries from 'util/country';
import { generateSurvey } from 'util/survey';

import Navigator from './component';

const initState = () => ({
	open: false,
});

const mapSetStateToProps = ({ open }, props, setState) => ({
	open,
	closeMenu: () => {
		setState({ open: false });
	},
	toggleMenu: () => {
		setState({ open: !open });
	},
	...props,
});

const NavigatorContainer = contain(initState, mapSetStateToProps)(Navigator);

const checkLoading = ({ loading, entering, changing }) =>
	loading.length > 0 || entering.length > 0 || changing.length > 0;

const calculateRatio = ({ loading, entering, changing, ratio }) => {
	const enteringRatio = entering.map(page => ratio[page]);
	const changingRatio = changing.map(page => ratio[page]);

	return (
		(enteringRatio.reduce((sum, cur) => sum + cur, 0) +
			changingRatio.reduce((sum, cur) => sum + cur, 0)) /
		(loading.length + enteringRatio.length + changingRatio.length)
	);
};

const checkTransparentWithPathname = pathname => {
	const pathArray = pathname.split('/');

	if (pathArray.length <= 2 && pathArray[0] !== 'auth') {
		return true;
	}

	if (
		pathname.includes('/room/') &&
		!pathname.includes('reservation') &&
		!pathname.includes('booking')
	) {
		return true;
	}

	return false;
};

const getSurveyOption = (name, email, phone, phoneCountry) => ({
	ssn11: name,
	ssn12: `+${AllCountries.getCountryByCode(phoneCountry).dialCode} ${phone}`,
	ssn13: email,
});

const mapStateToProps = ({
	routing: { locationBeforeTransitions: { pathname } },
	i18n: { lan },
	global: { route, scrollY, media },
	auth: { token: { accessToken } },
	user: { data: { imageUrl, nickname, name, phone, phoneCountry, email } },
}) => ({
	transparent: checkTransparentWithPathname(pathname) && scrollY === 0 && !checkLoading(route),
	loading: checkLoading(route),
	ratio: calculateRatio(route),
	media,
	routeName: languageMapRoute(lan),
	isLogin: accessToken !== '',
	suggestSruvey:
		accessToken === ''
			? generateSurvey('Mp63x')
			: generateSurvey('Mp63x', getSurveyOption(name, email, phone, phoneCountry)),
	avatar: imageUrl,
	nickname,
});

const mapDispatchToProps = dispatch => ({
	onOpenLoginSignupModal: type => dispatch(openMessageModal('loginSignup', { type })),
	onLogout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigatorContainer);



// WEBPACK FOOTER //
// ./src/components/molecules/Navigator/index.js